<template>
	
	<article class="resource-tile">
		<h3 class="title is-3 is-bold">{{resource.title}}</h3>
		<p>{{resource.caption}}</p>
		<a class="is-primary" :href="resource.url">{{resource.url}}</a>
	</article>
	
</template>
	
<script>
	export default {
		name: 'ResourceTile',
		
		props: ["resource"],
		
		data() {
			return {
				
			};
		},
	
		methods: {
			
		}
	}
</script>
